/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { getConsultById } from 'Selectors/webChat/consults';
import { bool, func, number, shape } from 'prop-types';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Button, Dimmer, Loader } from 'semantic-ui-react';

import { getDoctorPayout } from '../../../../../redux/modules/doctor/actions';

import Fee from './Fee';
import styles from './FeeContent.less';

import { getErrorMessage } from '@/utils/common';

const FeeContent = props => {
  const {
    onBack,
    consultFee,
    onNext,
    consultId,
    userDiscount,
    setUserDiscount,
    isLoading,
    loadingFinish,
    isViewMode,
    contextButton = 'Next',
  } = props;
  const dispatch = useDispatch();
  const {
    status: { estimate: estimateStatus },
    error: { estimate: errEstimate, updateFee: errUpdateFee },
  } = useSelector(state => state.webChat.consultFee);
  const errorEst = getErrorMessage(errEstimate ?? errUpdateFee);

  const consult = useSelector(state => getConsultById(state, consultId), shallowEqual);

  useEffect(() => {
    dispatch(getDoctorPayout());
  }, []);

  const isDisabled = estimateStatus === 0 || !!errorEst;
  return (
    <div style={{ position: 'relative' }}>
      <Dimmer active={isLoading} inverted>
        <Loader active />
      </Dimmer>
      {consultFee && (
        <>
          <div>
            <Fee
              {...props}
              userDiscount={userDiscount}
              setUserDiscount={setUserDiscount}
              next={onNext}
              consultFee={{ ...consultFee, consult }}
              isViewMode={isViewMode}
            />
          </div>
          {!isViewMode && consultFee.videoFee == null && (
            <div className={styles.actions}>
              <Button
                primary
                content={contextButton}
                onClick={onNext}
                disabled={isDisabled}
                loading={loadingFinish}
              />
              <Button content="Back" onClick={onBack} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

FeeContent.propTypes = {
  consultDiscount: number,
  consultFee: shape({}).isRequired,
  setConsultDiscount: func,
  onNext: func,
  onBack: func,
  consultId: number,
  isFixed: bool,
  isReadOnly: bool,
  finishConsult: func,
  loadingFinish: bool,
  isLoading: bool,
  isErrorFinish: bool,
  error: shape({}),
};

FeeContent.defaultProps = {
  setConsultDiscount: () => {},
  onNext: () => {},
  onBack: () => {},
  consultDiscount: 0,
  isFixed: false,
  isReadOnly: false,
  consultId: -1,
  finishConsult: () => {},
  error: null,
  loadingFinish: false,
  isErrorFinish: false,
  isLoading: false,
};

export default FeeContent;
